import {
  IPricingRule,
  IPricingRuleProvider,
  PricingRuleType,
} from '@principle-theorem/principle-core/interfaces';
import { first } from 'lodash';

export class VariablePricingProvider implements IPricingRuleProvider {
  canProvide(rule: IPricingRule): boolean {
    return rule.type === PricingRuleType.Variable;
  }

  determinePrice(pricingRule: IPricingRule): number | undefined {
    const selectedRule =
      pricingRule.ruleItems.find((rule) => rule.selected) ??
      first(pricingRule.ruleItems);
    return selectedRule?.price;
  }

  selectByLabel(pricingRule: IPricingRule, label: string): IPricingRule {
    return {
      ...pricingRule,
      ruleItems: pricingRule.ruleItems.map((ruleItem) => ({
        ...ruleItem,
        selected: ruleItem.label === label,
      })),
    };
  }
}
